import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, FieldArray, formValueSelector, reset, change, arrayInsert, arrayPush, arrayPop, arraySplice } from 'redux-form';
// import { Sticky, StickyContainer } from 'react-sticky';
import { RenderField, RenderSelectField, RenderSubmitButton, RenderCheckboxRadioField, RenderDropdownSelect } from '../../common/form'; // eslint-disable-line
import AddressFields from '../../common/form/AddressFields';
import GuestAffiliation from './GuestAffiliation';
import * as Validations from '../../common/form/commonValidations';
import { fetchGuestList, addGuestGroupV2 } from '../../../actions/GuestActions';
import { showModal, hideModal } from '../../../actions/ModalActions';
import { Prefix } from './GuestListTypes';
import GenericAccordion from '../../common/ui/GenericAccordion';
import { truncateText } from '../../../util/textUtil';


class RenderGuestRow extends Component {
  constructor(props) {
    super(props);

    this.getGuestValue = this.getGuestValue.bind(this);
    this.getFirstNameRequiredProps = this.getFirstNameRequiredProps.bind(this);
    this.getFamilyNameRequiredProps = this.getFamilyNameRequiredProps.bind(this);
    this.renderPrefixInput = this.renderPrefixInput.bind(this);
  }

  getGuestValue(name, index) {
    const { guestFormValues } = this.props;
    return guestFormValues && guestFormValues[index] && guestFormValues[index][name];
  }

  getFirstNameRequiredProps(index) {
    return this.getGuestValue('plus_one', index) ? {} : {
      required: true,
      validate: [Validations.REQUIRED, Validations.MAX_LENGTH_50]
    };
  }

  getFamilyNameRequiredProps(index) {
    const isPrimary = this.getGuestValue('relationship_type', index) === 'PRIMARY';
    const isPartner = this.getGuestValue('relationship_type', index) === 'PARTNER';
    if (isPrimary) {
      return isPrimary ? { required: true, validate: [Validations.REQUIRED, Validations.MAX_LENGTH_50] } : {};
    } else if (isPartner) {
      return isPartner ? { required: true, validate: Validations.MAX_LENGTH_50 } : {};
    }
    return undefined;
  }

  renderPrefixInput(guest, index) {
    if (this.getGuestValue('relationship_type', index) === 'CHILD') {
      return (
        <input className="form-control" value="Child" disabled />
      );
    } else if (this.getGuestValue('name_unknown', index)) {
      return (
        <input className="form-control" value="Guest" disabled />
      );
    }
    return (
      <Field
        name={`${guest}.prefix`}
        id="add-guest-group-prefix"
        options={Prefix}
        component={RenderDropdownSelect}
        hideFormGroup
        tooltip="Addressing your invitations formally? Include titles for your guests."
      />
    );
  }

  render() {
    const { name, index, fields, enableChildren } = this.props;
    const guest = name;
    const nameUnknown = this.getGuestValue('name_unknown', index);

    return (
      <div key={index} className="row form-group">
        <div className="col-xs-12 col-md-2">
          <div className="visible-xs visible-sm">
            <div className="with-tooltip" data-tooltip="Addressing your invitations formally? Include titles for your guests.">
              <div className="form-label">
                Title <i className="zolaicon zolaicon-info" />
              </div>
            </div>
            {this.renderPrefixInput(guest, index)}
          </div>
          <div className="hidden-xs hidden-sm">
            {this.renderPrefixInput(guest, index)}
          </div>
        </div>
        <div className="col-xs-12 col-md-4">
          <div className="visible-xs visible-sm">
            <div className="form-label">First Name</div>
          </div>
          {nameUnknown && (
            <input className="form-control" type="text" disabled />
          )}
          {!nameUnknown && (
            <Field
              name={`${guest}.first_name`}
              id="add-guest-group-first-name"
              type="text"
              component={RenderField}
              {...this.getFirstNameRequiredProps(index)}
              disabled={nameUnknown}
              hideValue={nameUnknown}
              hideFormGroup
            />
          )}
        </div>
        <div className="col-xs-12 col-md-4">
          <div className="visible-xs visible-sm">
            <div className="form-label">Last Name</div>
          </div>
          {nameUnknown && (
            <input className="form-control" type="text" disabled />
          )}
          {!nameUnknown && (
            <Field
              name={`${guest}.family_name`}
              id="add-guest-group-family-name"
              type="text"
              component={RenderField}
              {...this.getFamilyNameRequiredProps(index)}
              disabled={nameUnknown}
              hideFormGroup
            />
          )}
        </div>
        <div className="col-xs-12 col-md-2 visible-xs visible-sm">
          <div className="form-label">Suffix</div>
          {index > 0 && (
            <div className="guest-delete" onClick={() => fields.remove(index)}>X</div>
          )}
          {nameUnknown && (
            <input className="form-control" type="text" disabled />
          )}
          {!nameUnknown && (
            <Field
              name={`${guest}.suffix`}
              id="add-guest-group-suffix"
              type="text"
              component={RenderField}
              disabled={nameUnknown}
              hideFormGroup
              validate={Validations.MAX_LENGTH_20}
            />
          )}
        </div>
        <div className="col-xs-12 col-md-2 hidden-xs hidden-sm">
          {index > 0 && (
            <div className="guest-delete" onClick={() => fields.remove(index)}>
              <div className="with-tooltip" data-tooltip="Delete guest">X</div>
            </div>
          )}
          {nameUnknown && (
            <input className="form-control" type="text" disabled />
          )}
          {!nameUnknown && (
            <Field
              name={`${guest}.suffix`}
              id="add-guest-group-suffix"
              type="text"
              component={RenderField}
              disabled={nameUnknown}
              hideFormGroup
              validate={Validations.MAX_LENGTH_20}
            />
          )}
        </div>
        {index > 0 && (
          <div className="col-xs-12">
            <div className="with-tooltip" data-tooltip="Check off if you don't know a guest's or plus-one's name.">
              <Field
                id={`${guest}-add-guest-group-name-unknown`}
                name={`${guest}.name_unknown`}
                component={RenderCheckboxRadioField}
                type="checkbox"
                label="Name Unknown"
                styleOverride
                className="col-xs-10 col-md-12"
              />
              <span className="zolaicon zolaicon-info guest-unknown-zolaicon visible-xs visible-sm col-xs-2" />
            </div>
          </div>
        )}
        {(index === 0) && !(fields.get(index + 1) && (fields.get(index + 1).relationship_type === 'PARTNER')) && (
          <div className="col-xs-12 margin-top">
            <div className="with-tooltip" data-tooltip="Control who brings a plus-one.">
              <a role="button" className="plus-one-btn" onClick={() => fields.insert(1, { relationship_type: 'PARTNER', source: 'MANUAL' })}>+ Add Plus One</a>
              <i className="zolaicon zolaicon-info visible-xs-inline visible-sm-inline margin-left-2x" />
            </div>
          </div>
        )}
        {enableChildren && (index === fields.length - 1) && (
          <div className="col-xs-12">
            <a role="button" onClick={() => fields.push({ relationship_type: 'CHILD', source: 'MANUAL' })}>+ Add Child</a>
          </div>
        )}
      </div>
    );
  }
}

RenderGuestRow.propTypes = {
  name: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  fields: PropTypes.shape({}).isRequired,
  guestFormValues: PropTypes.arrayOf(PropTypes.shape({})),
  enableChildren: PropTypes.bool,
};

const RenderGuests = ({ fields, template, guestFormValues }) => {
  const enableChildren = template === 'FAMILY';

  return (
    <div>
      <div className="row hidden-xs hidden-sm">
        <div className="col-md-2">
          <div className="form-label">Title</div>
        </div>
        <div className="col-md-4">
          <div className="form-label">First Name</div>
        </div>
        <div className="col-md-4">
          <div className="form-label">Last Name</div>
        </div>
        <div className="col-md-2">
          <div className="form-label">Suffix</div>
        </div>
      </div>
      {fields.map((guestNameField, guestIndex, guestFieldsRef) => (
        <RenderGuestRow
          key={guestIndex}
          name={guestNameField}
          index={guestIndex}
          fields={guestFieldsRef}
          guestFormValues={guestFormValues}
          enableChildren={enableChildren}
        />
      ))}
    </div>
  );
};

RenderGuests.propTypes = {
  template: PropTypes.string,
  fields: PropTypes.shape({}),
  guestFormValues: PropTypes.arrayOf(PropTypes.shape({}))
};

// const handleStateChange = (status) => {
//   console.log(status);
//   if (status.status === Sticky.STATUS_FIXED) {
//     console.log('the component is sticky');
//   }
// };

function RenderEventInvitation({ eventInvitation, formValues, index, disabled }) {
  return (
    <Field
      id={eventInvitation}
      name={`${eventInvitation}.checked`}
      component={RenderCheckboxRadioField}
      label={formValues && truncateText(formValues[index].name, 30)}
      type="checkbox"
      styleOverride
      inline
      className={disabled ? 'checkbox-disabled' : 'checkbox-secondary'}
      disabled={disabled}
    />
  );
}

RenderEventInvitation.propTypes = {
  eventInvitation: PropTypes.string,
  index: PropTypes.number,
  formValues: PropTypes.arrayOf(PropTypes.shape({})),
  disabled: PropTypes.bool,
};

function RenderEventInvitations({ fields, id, label, hideFormGroup, meta: { touched, error }, formValues, disabled }) {
  return (
    <div className={`${hideFormGroup ? '' : 'form-group'} ${disabled ? 'event-invitations-disabled' : ''} ${touched && error ? 'has-error' : ''}`}>
      <label htmlFor={id} className="margin-right-2x">{label}</label>
      <div id={id} className="visible-xs-inline visible-sm-inline visible-md-inline visible-lg-inline">
        {fields.map((eventInvitation, index, fieldsRef) => (
          <RenderEventInvitation
            key={index}
            eventInvitation={eventInvitation}
            index={index}
            fields={fieldsRef}
            formValues={formValues}
            disabled={disabled}
          />
        ))}
      </div>
    </div>
  );
}

RenderEventInvitations.propTypes = {
  fields: PropTypes.shape({}),
  id: PropTypes.string,
  label: PropTypes.string,
  hideFormGroup: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  formValues: PropTypes.arrayOf(PropTypes.shape({})),
  disabled: PropTypes.bool,
};

const AddGuestGroupForm = (props) => {
  const { wedding, template, guestFormValues, eventFormValues, handleSubmit, pristine, submitting, valid, onSubmitAndClose, onSubmitAndRequestMissingInfo, onChangeTemplate, invitedFormValue } = props;

  const accordionItems = [
    {
      heading: 'Mailing Address',
      body: (
        <AddressFields selector={'addGuestGroupForm'} minimal optional addressMessage="Formally addressing your invitations? Avoid Rd, St, Apt, etc." />
      ),
      open: false
    },
    {
      heading: 'Email & Mobile',
      body: (
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <Field
              name="email_address"
              label="Email"
              id="edit-guest-group-email"
              type="email"
              component={RenderField}
              validate={Validations.MAX_LENGTH_100}
            />
          </div>
          <div className="col-xs-12 col-md-6">
            <Field
              name="mobile_phone"
              label="Mobile"
              id="add-guest-group-mobile-phone"
              type="tel"
              component={RenderField}
              validate={Validations.MAX_LENGTH_25}
            />
          </div>
        </div>
      ),
      open: false
    }
  ];

  return (
    <form onSubmit={handleSubmit} id="add-guest-group-form">
      <div>
        <div className="row margin-top margin-bottom-2x">
          <div className="col-xs-12 text-center change-template-buttons">
            <div onClick={() => onChangeTemplate('SINGLE', guestFormValues)} className={`btn btn-secondary btn-boxed ${template === 'SINGLE' ? ' active' : ''}`}>
              <i className="zolaicon zolaicon-individual" /> Single <span className="hidden-xs">Person</span>
            </div>
            <div onClick={() => onChangeTemplate('COUPLE', guestFormValues)} className={`btn btn-secondary btn-boxed ${template === 'COUPLE' ? ' active' : ''}`}>
              <i className="zolaicon zolaicon-couple" /> Couple
            </div>
            <div onClick={() => onChangeTemplate('FAMILY', guestFormValues)} className={`btn btn-secondary btn-boxed ${template === 'FAMILY' ? ' active' : ''}`}>
              <i className="zolaicon zolaicon-family" /> Family
            </div>
          </div>
        </div>
        <FieldArray
          name="guests"
          component={RenderGuests}
          template={template}
          guestFormValues={guestFormValues}
        />
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <div className="visible-xs visible-sm">
              <span className="form-label margin-right-1x">Relationship to You</span><div className="with-tooltip relationship-select-container" data-tooltip="Indicate how you know your guests to help filter your list."><i className="zolaicon zolaicon-info" /></div>
              <Field
                name="affiliation"
                id="add-guest-group-guest-affiliation-test"
                component={RenderDropdownSelect}
                options={GuestAffiliation(wedding.owner_first_name, wedding.partner_first_name)}
                tooltip="Indicate how you know your guests to help filter your list."
                hideEmpty
              />
            </div>
            <div className="visible-md visible-lg">
              <Field
                name="affiliation"
                id="add-guest-group-guest-affiliation-test"
                component={RenderDropdownSelect}
                options={GuestAffiliation(wedding.owner_first_name, wedding.partner_first_name)}
                label="Relationship To You"
                tooltip="Indicate how you know your guests to help filter your list."
                hideEmpty
              />
            </div>
          </div>
          <div className="col-xs-12 form-group invited-to-wedding">
            <div className="with-tooltip margin-right-2x" data-tooltip="Tame your guest list with these filters by marking who's &quot;Definitely&quot; and &quot;Maybe&quot; invited.">
              <span className="form-label margin-right-1x wedding-label">Invited?</span><i className="zolaicon zolaicon-info visible-xs-inline visible-sm-inline" />
            </div>
            <div style={{ display: 'inline-block' }}>
              <span className="with-tooltip no-tooltip-on-mobile margin-right-2x" data-tooltip="These are guests you cannot imagine your wedding without. Using our online RSVP feature on your wedding website? Guests marked as &quot;Definitely&quot; will be able to RSVP online.">
                <Field
                  id="add-guest-group-invited-definitely"
                  name="invited"
                  component={RenderCheckboxRadioField}
                  type="radio"
                  label="Definitely"
                  styleOverride
                  value="true"
                  inline
                />
              </span>
              <span className="with-tooltip no-tooltip-on-mobile" data-tooltip="These are the guests you’re still thinking over. Using our online RSVP feature on your wedding website? Guests marked as &quot;Maybe&quot; will NOT be able to RSVP online.">
                <Field
                  id="add-guest-group-invited-maybe"
                  name="invited"
                  component={RenderCheckboxRadioField}
                  type="radio"
                  label="Maybe"
                  styleOverride
                  value="false"
                  inline
                />
              </span>
            </div>
          </div>
          {eventFormValues.length > 0 && (
            <div className="col-xs-12 col-sm-12 event-invitations">
              <FieldArray
                name="event_invitations"
                component={RenderEventInvitations}
                label="Events Invited To"
                id="event-invitations"
                formValues={eventFormValues}
                disabled={invitedFormValue === 'false'}
              />
            </div>
          )}
        </div>
      </div>
      <div className="missing-contact-info">
        <div className="text-large missing-contact-info-label">Don&#39;t have all your guest&#39;s information?</div>
        <div className="btn btn-secondary missing-contact-info-btn" onClick={handleSubmit(onSubmitAndRequestMissingInfo)}>Request Missing Info</div>
      </div>
      <GenericAccordion items={accordionItems} allowMultiple />
      <ul className="list-inline add-guest-group-buttons">
        <li>
          <RenderSubmitButton pristine={pristine} submitting={submitting} valid={valid} value="Save &amp; Add Another" hideFormGroup />
        </li>
        <li>
          <a role="button" className={`btn btn-secondary ${!valid ? ' disabled' : ''}`} disabled={!valid} onClick={handleSubmit(onSubmitAndClose)}>Save &amp; Close</a>
        </li>
      </ul>
    </form>
  );
};

AddGuestGroupForm.propTypes = {
  wedding: PropTypes.shape({
    owner_first_name: PropTypes.string.isRequired,
    partner_first_name: PropTypes.string.isRequired
  }),
  template: PropTypes.string,
  guestFormValues: PropTypes.arrayOf(PropTypes.shape({})),
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  onSubmitAndClose: PropTypes.func.isRequired,
  onSubmitAndRequestMissingInfo: PropTypes.func,
  onChangeTemplate: PropTypes.func,
  eventFormValues: PropTypes.arrayOf(PropTypes.shape({})),
  invitedFormValue: PropTypes.string,
};

const guestTemplates = {
  SINGLE: [{
    relationship_type: 'PRIMARY',
    source: 'MANUAL'
  }],
  COUPLE: [{
    relationship_type: 'PRIMARY',
    source: 'MANUAL'
  }, {
    relationship_type: 'PARTNER',
    source: 'MANUAL'
  }],
  FAMILY: [{
    relationship_type: 'PRIMARY',
    source: 'MANUAL'
  }, {
    relationship_type: 'PARTNER',
    source: 'MANUAL'
  }, {
    relationship_type: 'CHILD',
    source: 'MANUAL'
  }]
};

const selector = formValueSelector('addGuestGroupForm');

const mapStateToProps = (state, ownProps) => {
  const initialGuests = guestTemplates[ownProps.template] || guestTemplates.SINGLE;

  const eventInvitations = state.events.events.orderedIds.map((eventId) => {
    const event = state.events.events.byId[eventId];
    const eventInvitation = {
      name: event.name,
      event_id: eventId,
      checked: event.public,
      meal_option_id: null,
      rsvp_type: 'NO_RESPONSE',
      rsvp_at: null,
    };
    return eventInvitation;
  });

  return {
    initialValues: {
      template: ownProps.template,
      guests: initialGuests,
      invited: 'true',
      country_code: 'US',
      tier: 'A',
      affiliation: 'UNKNOWN',
      include_plus_one: 'false',
      event_invitations: eventInvitations
    },
    template: selector(state, 'template'),
    invitedFormValue: selector(state, 'invited'),
    guestFormValues: selector(state, 'guests'),
    eventFormValues: selector(state, 'event_invitations') || [],
    wedding: state.wedding.wedding
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: (createGuestGroupRequest) => {
    dispatch(addGuestGroupV2(createGuestGroupRequest)).then((res) => {
      if (ownProps.callback) ownProps.callback(res);
      dispatch(reset('addGuestGroupForm'));
    });
  },
  onSubmitAndClose: (createGuestGroupRequest) => {
    dispatch(addGuestGroupV2(createGuestGroupRequest)).then((res) => {
      if (ownProps.callback) ownProps.callback(res);
      dispatch(hideModal());
    });
  },
  onSubmitAndRequestMissingInfo: (createGuestGroupRequest) => {
    dispatch(addGuestGroupV2(createGuestGroupRequest)).then((guestGroup) => {
      const { id } = guestGroup;
      dispatch(fetchGuestList()).then(() => (
        dispatch(showModal('REQUEST_MISSING_INFO_V2', { guestGroupIds: [id], fromAddGuestForm: true })))
      );
    });
  },
  onChangeTemplate: (type, values) => {
    dispatch(change('addGuestGroupForm', 'template', type));
    if (type === 'SINGLE') {
      if (values.length > 1) {
        dispatch(arraySplice('addGuestGroupForm', 'guests', 1, values.length - 1));
      }
    } else if (type === 'COUPLE') {
      if (values.length < 2) {
        dispatch(arrayInsert('addGuestGroupForm', 'guests', 1, { relationship_type: 'PARTNER', source: 'MANUAL' }));
      } else if (values.length === 2) {
        if (values[1].relationship_type !== 'PARTNER') {
          dispatch(arrayPop('addGuestGroupForm', 'guests'));
          dispatch(arrayPush('addGuestGroupForm', 'guests', { relationship_type: 'PARTNER', source: 'MANUAL' }));
        }
      } else if (values.length > 2) {
        if (values[1].relationship_type !== 'PARTNER') {
          dispatch(arraySplice('addGuestGroupForm', 'guests', 1, values.length - 1));
          dispatch(arrayPush('addGuestGroupForm', 'guests', { relationship_type: 'PARTNER', source: 'MANUAL' }));
        } else {
          dispatch(arraySplice('addGuestGroupForm', 'guests', 2, values.length - 1));
        }
      }
    } else if (type === 'FAMILY') {
      if (values.length === 1) {
        dispatch(arrayPush('addGuestGroupForm', 'guests', { relationship_type: 'PARTNER', source: 'MANUAL' }));
        dispatch(arrayPush('addGuestGroupForm', 'guests', { relationship_type: 'CHILD', source: 'MANUAL' }));
      } else if (values.length === 2) {
        dispatch(arrayPush('addGuestGroupForm', 'guests', { relationship_type: 'CHILD', source: 'MANUAL' }));
      }
    }
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({
  form: 'addGuestGroupForm',
})(AddGuestGroupForm));



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/AddGuestGroupFormV2.jsx